import { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { loginWithGoogle } from '../services/authService';

export default function LoginPage() {
  const { isAuthenticated, login } = useAuth();
  const [error, setError] = useState('');

  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const handleSuccess = async (credentialResponse) => {
    setError('');
    try {
      const data = await loginWithGoogle(credentialResponse.credential);
      login(data.token, {
        email: data.email,
        name: data.name,
        picture: data.picture,
      });
    } catch (err) {
      const message =
        err.response?.data?.error || 'Đăng nhập thất bại. Vui lòng thử lại.';
      setError(message);
    }
  };

  return (
    <div className="flex h-screen items-center justify-center bg-slate-50">
      <div className="w-full max-w-sm rounded-xl border border-cyan-100 bg-white p-8 shadow-sm">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-cyan-700">
          AK Admin
        </p>
        <h1 className="mt-1 text-lg font-semibold text-slate-900">
          Đăng nhập
        </h1>
        <p className="mt-2 text-sm text-slate-500">
          Chỉ các email được cấp quyền mới có thể truy cập trang quản trị.
        </p>

        <div className="mt-6 flex justify-center">
          <GoogleLogin onSuccess={handleSuccess} onError={() => setError('Đăng nhập Google thất bại.')} />
        </div>

        {error && (
          <p className="mt-4 text-center text-sm text-red-600">{error}</p>
        )}
      </div>
    </div>
  );
}
